package com.example.mystybag.login.model

data class MerchantRegistrationPaymentDataUIState(
    val iban: String = "",
    val ibanError: String? = null,
    val isLoading: Boolean = false
)

